import { FC } from "react"

/* ================= TYPES ================= */

type RightItemData = {
    label: string
    icon: string
}

type RightItemProps = {
    label: string
    icon: string
}

/* ================= COMPONENT CON ================= */

const RightItem: FC<RightItemProps> = ({ label, icon }) => {
    return (
        <div
            className="styles_RightPanelItem__DPU5m"
            role="button"
            tabIndex={0}
        >
            <div className="styles_RightPanelItemContent___OTW6">
                <div className="styles_RightPanelIcon__s_LEU">
                    <span
                        style={{
                            boxSizing: "border-box",
                            display: "inline-block",
                            overflow: "hidden",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0,
                            position: "relative",
                            maxWidth: "100%",
                        }}
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "block",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: 0,
                                margin: 0,
                                padding: 0,
                                maxWidth: "100%",
                            }}
                        >
                            <img
                                alt=""
                                aria-hidden="true"
                                src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='60'%20height='60'/%3e"
                                style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                }}
                            />
                        </span>

                        <img
                            alt={label}
                            src={icon}
                            decoding="async"
                            data-nimg="intrinsic"
                            style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                padding: 0,
                                border: "none",
                                margin: "auto",
                                display: "block",
                                width: 0,
                                height: 0,
                                minWidth: "100%",
                                maxWidth: "100%",
                                minHeight: "100%",
                                maxHeight: "100%",
                            }}
                        />
                    </span>
                </div>

                <span className="styles_RightPanelLabel__NWtS9">
                    {label}
                </span>
            </div>
        </div>
    )
}

/* ================= DATA ================= */

const RIGHT_ITEMS: RightItemData[] = [
    {
        label: "Kháng vi sinh vật",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/20258e1c24d17f7686d93472e53e747c1127079_1.svg",
    },
    {
        label: "Giảm đau, hạ sốt, kháng viêm",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/2025d8ff3654ff8fde6135200cebaf4d2419_1.svg",
    },
    {
        label: "Tim, mạch, huyết áp",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/2025553b0d193cff3e8dc6f4d606e00f1584_1.svg",
    },
    {
        label: "Hormon, sinh lý",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/20250dce00f8986da64b3257050516731421_1.svg",
    },
    {
        label: "Tai, mũi, họng",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/20259715ee97cfd1343b8ed4d562b8271715_1.svg",
    },
    {
        label: "Đái tháo đường",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/2025874110c4c4867c1469a9ca523e311255_1.svg",
    },
    {
        label: "Tiêu hóa, dạ dày",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/202559a8ba88c150d95844cb5c9568df1505_1.svg",
    },
    {
        label: "Não, thần kinh",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/2025fbde9e78154246a6a7803bfd49c21236_1.svg",
    },
    {
        label: "Da liễu",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/20255d7df2d5ecaed898c99327af446c1749_1.svg",
    },
    {
        label: "Mắt",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/202577f2795e4473ebe4919053d6d4861608_1.svg",
    },
    {
        label: "Máu, huyết học",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/20253589b63afb64e95ab863918283e61462_1.svg",
    },
    {
        label: "Cơ, xương, khớp",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/20257836704e2c7c9cd00136c2428316112011_1.svg",
    },
    {
        label: "Vitamin, khoáng chất",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/2025853ac3e4dd2542dccc1dccc874041733_1.svg",
    },
    {
        label: "Kháng Histamin (Chống dị ứng)",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/2025d95c1cc919bdf8750348b98d0f01284394_1.svg",
    },
    {
        label: "Miếng dán, dầu, cao xoa",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/2025fa583ae6a9a24a5686bc9dda412574170_1.svg",
    },
    {
        label: "Ung thư, miễn dịch",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/2025b6cc817b12b77d80e78eda0ee52f11466_1.svg",
    },
]

/* ================= COMPONENT CHA ================= */

const RightPanel: FC = () => {
    return (
        <div className="styles_RightPanel__f_KDj">
            <div className="styles_RightPaneCover__V18Ol">
                {RIGHT_ITEMS.map(item => (
                    <RightItem
                        key={item.label}
                        label={item.label}
                        icon={item.icon}
                    />
                ))}
            </div>
        </div>
    )
}

export default RightPanel
